import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import styled from 'styled-components';
import { CheckboxIconIndeterminate, CheckboxIconLocked, CheckboxIconCustom, CheckboxIconChecked, CheckboxIconUnchecked } from './CheckboxIcons.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["as", "className", "disabled", "icon", "iconChecked", "indeterminate", "readOnly", "size", "type"];
var CheckboxInput = styled.input.withConfig({
  displayName: "Checkbox__CheckboxInput",
  componentId: "sc-tti4h3-0"
})(["&&{cursor:inherit;opacity:0;height:100%;width:100%;margin:0;padding:0;position:absolute;top:0;inset-inline-start:0;}"]);
var CheckboxWrapper = styled.div.withConfig({
  displayName: "Checkbox__CheckboxWrapper",
  componentId: "sc-tti4h3-1"
})(["&&{border-radius:", "px;cursor:pointer;font-size:0;line-height:0;position:relative;display:inline-flex;vertical-align:middle;transition:transform,0.1s;", ";}&&:focus-within{outline:", ";outline-offset:2px;}@media (prefers-reduced-motion:reduce){&&{transition:none}}"], function (props) {
  return props.$size > 19 ? 4 : 3;
}, function (props) {
  return props.$disabled && "\n            cursor: not-allowed;\n    ";
}, function (props) {
  return "1px solid ".concat(props.theme.CTAColors.primaryVariant);
});
var checkboxComponents = {
  CheckboxWrapper: CheckboxWrapper
};
var Checkbox = /*#__PURE__*/React.forwardRef(function Checkbox2(props, ref) {
  var as = props.as,
    className = props.className,
    disabled = props.disabled,
    Icon = props.icon,
    IconChecked = props.iconChecked;
    props.indeterminate;
    var readOnly = props.readOnly,
    _props$size = props.size,
    size = _props$size === void 0 ? 16 : _props$size;
    props.type;
    var rest = _objectWithoutProperties(props, _excluded);
  var checked = props.checked || props.defaultChecked;
  return /*#__PURE__*/jsxs(CheckboxWrapper, {
    $disabled: disabled,
    className: className,
    $size: size,
    children: [function () {
      if (props.indeterminate) {
        return /*#__PURE__*/jsx(CheckboxIconIndeterminate, {
          disabled: disabled,
          size: size
        });
      }
      if (props.locked) {
        return /*#__PURE__*/jsx(CheckboxIconLocked, {
          disabled: disabled,
          size: size
        });
      }
      if (checked) {
        if (IconChecked) {
          return /*#__PURE__*/jsx(CheckboxIconCustom, {
            disabled: disabled,
            children: /*#__PURE__*/jsx(IconChecked, {
              size: size
            })
          });
        }
        return /*#__PURE__*/jsx(CheckboxIconChecked, {
          disabled: disabled,
          size: size
        });
      }
      if (Icon) return /*#__PURE__*/jsx(CheckboxIconCustom, {
        disabled: disabled,
        children: /*#__PURE__*/jsx(Icon, {
          size: size
        })
      });
      return /*#__PURE__*/jsx(CheckboxIconUnchecked, {
        disabled: disabled,
        size: size
      });
    }(), /*#__PURE__*/jsx(CheckboxInput, _objectSpread(_objectSpread({}, rest), {}, {
      as: as,
      disabled: disabled,
      readOnly: readOnly,
      ref: ref,
      type: !as || as === "input" ? "checkbox" : void 0,
      onChange: readOnly ? void 0 : props.onChange
    }))]
  });
});
Checkbox.displayName = "Checkbox";

export { Checkbox, checkboxComponents };
